const en = {
  nav: {
    home: "Home",
    salons: "Salons",
    membership: "Membership",
    shop: "Shop",
    academy: "Academy",
    blog: "Journal",
    login: "Login",
    logout: "Log Out",
    dashboard: "Dashboard",
    bookings: "My Bookings",
    loyalty: "Loyalty",
    profile: "Profile",
    orders: "My Orders",
    chat: "Conversations",
    notifications: "Notifications",
    partner: "Partner",
    admin: "Admin",
    partner_panel: "Partner Panel",
    admin_panel: "Admin Panel",
    login_register: "Login / Register",
    skip_to_content: "Skip to content",
    account_menu: "Account menu",
    primary_nav: "Primary",
    mobile_nav: "Mobile navigation",
    ai_advisor: "AI Advisor",
    cart: "Shopping cart",
  },
  footer: {
    tagline: "India's premium salon booking platform — bringing luxury beauty to your fingertips.",
    company: "Company",
    about: "About",
    how_it_works: "How it works",
    partners: "For Partners",
    stylists: "For Stylists",
    careers: "Careers",
    contact: "Contact",
    support: "Support",
    faq: "FAQ",
    help: "Help Centre",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    refund: "Refund Policy",
    services: "Services",
    salons: "Salons",
    membership: "Membership",
    shop: "Shop",
    academy: "Academy",
    connect: "Connect",
    newsletter_title: "Join our newsletter",
    newsletter_sub: "Beauty tips, exclusive offers, no spam.",
    newsletter_placeholder: "Your email",
    newsletter_cta: "Subscribe",
    copyright: "© {{year}} Fayriza. All rights reserved.",
    made_in: "Crafted in India",
  },
  home: {
    hero_eyebrow: "India's Premium Salon Network",
    hero_title: "Discover Your Perfect Salon Experience",
    hero_subtitle: "Book appointments at top-rated salons near you — luxury, convenience, and care.",
    search_placeholder: "Search salons, services or stylists…",
    search_cta: "Find a Salon",
    featured_salons: "Featured Salons",
    browse_all: "Browse All",
    view_all: "View All",
    categories_title: "Explore Categories",
    categories_sub: "Curated services for every occasion",
    why_title: "Why Fayriza",
    why_sub: "A premium experience, end to end",
    why_1_title: "Verified Salons",
    why_1_body: "Every partner salon is hand-picked and quality-checked.",
    why_2_title: "Instant Booking",
    why_2_body: "Real-time availability, confirmed in seconds.",
    why_3_title: "Secure Payments",
    why_3_body: "Razorpay-backed, refund-protected transactions.",
    why_4_title: "Loyalty & Rewards",
    why_4_body: "Earn points on every visit, redeem for perks.",
    testimonials_title: "Loved by our community",
    cta_title: "Ready to glow?",
    cta_sub: "Join thousands of Fayriza members.",
    cta_btn: "Get Started",
  },
  salons: {
    title: "All Salons",
    subtitle: "Browse premium partner salons near you",
    filter: "Filter",
    sort: "Sort",
    sort_relevance: "Relevance",
    sort_rating: "Top Rated",
    sort_price_asc: "Price: Low to High",
    sort_price_desc: "Price: High to Low",
    sort_nearest: "Nearest",
    search_placeholder: "Search by name or area…",
    categories_all: "All",
    city_all: "All Cities",
    price_range: "Price range",
    open_now: "Open now",
    no_results_title: "No salons match your filters",
    no_results_sub: "Try clearing a filter or searching a different area.",
    clear_filters: "Clear filters",
    showing: "Showing {{count}} salons",
    loading: "Loading salons…",
    book_now: "Book Now",
    from: "From",
    per_service: "per service",
    results: "results",
    filters_title: "Filters",
    reset_all: "Reset all",
    category: "Category",
    min_rating: "Min Rating",
    any_rating: "Any rating",
    for_gender: "For",
    gender_women: "Women",
    gender_men: "Men",
    gender_unisex: "Unisex",
    cat_bridal: "Bridal",
    cat_spa: "Spa",
  },
  salon: {
    book_now: "Book Now",
    message: "Message",
    favourite: "Favourite",
    unfavourite: "Remove Favourite",
    share: "Share",
    directions: "Directions",
    call: "Call",
    services: "Services",
    stylists: "Stylists",
    reviews: "Reviews",
    availability: "Availability",
    gallery: "Gallery",
    about: "About",
    working_hours: "Working Hours",
    amenities: "Amenities",
    contact: "Contact",
    overview: "Overview",
    location: "Location",
    reviews_count: "{{count}} reviews",
    rating_out_of: "{{rating}} out of 5",
    select_service: "Select a service to book",
    duration: "Duration",
    minutes: "{{min}} min",
    open: "Open",
    closed: "Closed",
    closes_at: "Closes at {{time}}",
    opens_at: "Opens at {{time}}",
  },
  booking: {
    title: "Book an appointment",
    step_services: "Services",
    step_stylist: "Stylist",
    step_datetime: "Date & Time",
    step_review: "Review",
    step_pay: "Payment",
    select_services: "Select Services",
    select_stylist: "Select Stylist",
    any_stylist: "Any available stylist",
    select_date: "Select Date",
    select_time: "Select Time",
    no_slots: "No slots available for this date",
    try_other_date: "Try a different date",
    confirm: "Confirm Booking",
    cancel: "Cancel Booking",
    reschedule: "Reschedule",
    subtotal: "Subtotal",
    discount: "Discount",
    tax: "Taxes & Fees",
    total: "Total",
    pay_now: "Pay Now",
    pay_at_salon: "Pay at Salon",
    use_wallet: "Use Wallet",
    apply_offer: "Apply Offer",
    offer_placeholder: "Enter code",
    apply: "Apply",
    remove: "Remove",
    booking_confirmed: "Booking Confirmed!",
    booking_cancelled: "Booking Cancelled",
    booking_ref: "Booking ID",
    when: "When",
    where: "Where",
    who: "With",
    notes: "Add a note (optional)",
    notes_placeholder: "Allergies, preferences…",
    upcoming: "Upcoming",
    past: "Past",
    cancelled: "Cancelled",
    view_details: "View Details",
    download_receipt: "Download Receipt",
    rate_visit: "Rate this visit",
  },
  auth: {
    login_title: "Welcome Back",
    login_sub: "Sign in to continue to Fayriza",
    register_title: "Create Account",
    register_sub: "Join India's premium salon network",
    email: "Email",
    email_placeholder: "you@example.com",
    password: "Password",
    password_placeholder: "At least 8 characters",
    phone: "Phone Number",
    phone_placeholder: "10-digit mobile number",
    name: "Full Name",
    name_placeholder: "Your name",
    otp: "Enter OTP",
    otp_placeholder: "6-digit code",
    send_otp: "Send OTP",
    verify_otp: "Verify",
    resend_otp: "Resend OTP",
    resend_in: "Resend in {{s}}s",
    login_cta: "Sign In",
    register_cta: "Create Account",
    forgot_password: "Forgot Password?",
    reset_password: "Reset Password",
    reset_sub: "Enter your email and we'll send a reset link",
    reset_sent: "Reset link sent to your email",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    social_login: "Or continue with",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "Verify Email",
    verify_email_sub: "We sent a verification link to {{email}}",
    resend_email: "Resend verification email",
    accept_terms: "I agree to the Terms and Privacy Policy",
    switch_to_register: "Don't have an account?",
    switch_to_register_cta: "Sign up",
    switch_to_login: "Already have an account?",
    switch_to_login_cta: "Sign in",
    remember_me: "Remember me",
    phone_or_email: "Phone or Email",
    use_phone: "Use phone instead",
    use_email: "Use email instead",
    didnt_receive: "Didn't receive code?",
  },
  profile: {
    title: "My Profile",
    edit_profile: "Edit Profile",
    change_password: "Change Password",
    avatar: "Profile Photo",
    upload_photo: "Upload Photo",
    name: "Full Name",
    phone: "Phone Number",
    email: "Email",
    dob: "Date of Birth",
    gender: "Gender",
    gender_male: "Male",
    gender_female: "Female",
    gender_other: "Other",
    address: "Address",
    city: "City",
    pincode: "Pincode",
    save: "Save Changes",
    saved: "Profile updated",
    current_password: "Current Password",
    current_password_placeholder: "Enter current password",
    new_password: "New Password",
    new_password_placeholder: "At least 8 characters",
    password_changed: "Password changed successfully",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome back, {{name}}",
    upcoming_bookings: "Upcoming Bookings",
    no_upcoming: "No upcoming appointments",
    book_a_salon: "Book a salon",
    favourites: "Favourite Salons",
    no_favourites: "You haven't favourited any salons yet",
    loyalty_points: "Loyalty Points",
    wallet_balance: "Wallet Balance",
    recent_activity: "Recent Activity",
    quick_actions: "Quick Actions",
    view_all: "View All",
    manage_membership: "Manage Membership",
    top_up_wallet: "Top Up Wallet",
    refer_friend: "Refer a Friend",
  },
  common: {
    loading: "Loading…",
    error: "Something went wrong",
    retry: "Retry",
    no_results: "No results found",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    view_all: "View All",
    see_more: "See More",
    see_less: "See Less",
    back: "Back",
    next: "Next",
    previous: "Previous",
    submit: "Submit",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    save: "Save",
    close: "Close",
    confirm: "Confirm",
    continue: "Continue",
    yes: "Yes",
    no: "No",
    skip: "Skip",
    optional: "Optional",
    required: "Required",
    from: "from",
    per: "per",
    to: "to",
    and: "and",
    or: "or",
    learn_more: "Learn More",
    coming_soon: "Coming Soon",
    currency: "₹",
    minutes_short: "min",
    hours_short: "hr",
    km: "km",
    away: "away",
    stars: "stars",
  },
  loyalty: {
    title: "Fayriza Loyalty",
    subtitle: "Earn points on every visit, redeem for rewards",
    points: "Points",
    available_points: "Available Points",
    total_earned: "Total Earned",
    total_redeemed: "Total Redeemed",
    redeem: "Redeem",
    history: "Points History",
    rewards: "Rewards",
    tier: "Tier",
    how_it_works: "How It Works",
    earn_title: "Earn",
    earn_body: "1 point for every ₹10 spent. 2× on Gold, 3× on Platinum.",
    redeem_title: "Redeem",
    redeem_body: "Use points for wallet credit, free services, or partner perks.",
    empty_history: "No points activity yet",
    empty_rewards: "No rewards available right now",
  },
  wallet: {
    title: "Fayriza Wallet",
    subtitle: "Top up once, book frictionlessly",
    balance: "Balance",
    available: "Available",
    topup: "Top Up",
    topup_cta: "Add Money",
    topup_amount: "Amount",
    history: "Transaction History",
    empty_history: "No transactions yet",
    credit: "Credit",
    debit: "Debit",
    refund: "Refund",
  },
  membership: {
    eyebrow: "Exclusive Access",
    hero_title: "Fayriza Membership Plans",
    hero_sub: "Unlock exclusive discounts, priority booking and luxury perks across 500+ premium salons in India.",
    plans: "Membership Plans",
    subscribe: "Subscribe",
    cancel: "Cancel Membership",
    current: "Current Plan",
    gold: "Gold",
    silver: "Silver",
    platinum: "Platinum",
    per_year: "/year",
    per_month_approx: "≈ ₹{{amount}}/month",
    cancel_anytime: "Cancel anytime",
    choose_title: "Choose Your Plan",
    choose_sub: "All plans are billed annually. Select a plan and confirm to activate instantly.",
    most_popular: "Most Popular",
    get_plan: "Get {{plan}}",
    selected_proceed: "Selected — Proceed to Pay →",
    processing: "Processing…",
    current_plan_label: "✓ Current Plan",
    welcome_back: "Welcome back, {{name}}!",
    member_label: "Fayriza {{tier}} Member",
    expires_in: "expires in {{days}} days",
    renews_on: "renews on {{date}}",
    your_discount: "Your discount",
    off_all: "off all services",
    expiring_warn: "Your membership expires soon. Renew now to keep your discounts.",
    feature_comparison: "Full Feature Comparison",
    feature: "Feature",
    benefits_500: "500+ Partner Salons",
    benefits_instant: "Instant Activation",
    benefits_cancel: "Cancel Anytime",
    benefits_refund: "7-Day Money Back",
    faq_title: "Frequently Asked Questions",
    faq_cancel_q: "Can I cancel my membership?",
    faq_cancel_a: "Yes. You can cancel anytime from your dashboard. Your benefits continue until the end of your billing period.",
    faq_all_salons_q: "Does the discount apply to all salons?",
    faq_all_salons_a: "Yes — the discount applies automatically at all 500+ verified Fayriza partner salons across India.",
    faq_refund_q: "What is the 7-day money back guarantee?",
    faq_refund_a: "If you're not satisfied within 7 days of activation, we'll refund your membership fee in full — no questions asked.",
    faq_upgrade_q: "Can I upgrade my plan?",
    faq_upgrade_a: "Yes. You can upgrade anytime. You'll be charged the prorated difference for the remaining period.",
    activated: "🎉 Fayriza {{plan}} activated!",
    subscribe_failed: "Subscription failed. Please try again.",
  },
  shop: {
    eyebrow: "Fayriza Shop",
    hero_title: "Premium Beauty & Grooming Products",
    hero_sub: "Curated professional-grade essentials, delivered to your door.",
    search_placeholder: "Search products…",
    categories: "Categories",
    all_products: "All Products",
    add_to_cart: "Add to Cart",
    added: "Added ✓",
    out_of_stock: "Out of stock",
    checkout: "Checkout",
    cart: "Cart",
    cart_empty: "Your cart is empty",
    cart_empty_sub: "Start shopping to fill it up",
    products: "Products",
    orders: "My Orders",
    no_orders: "No orders yet",
    order_ref: "Order ID",
    order_status: "Status",
    order_placed: "Placed",
    order_shipped: "Shipped",
    order_delivered: "Delivered",
    order_cancelled: "Cancelled",
    qty: "Qty",
    remove: "Remove",
    subtotal: "Subtotal",
    shipping: "Shipping",
    tax: "Tax",
    total: "Total",
    proceed_checkout: "Proceed to Checkout",
    shipping_address: "Shipping Address",
    place_order: "Place Order",
    continue_shopping: "Continue Shopping",
    product_details: "Product Details",
    description: "Description",
    specifications: "Specifications",
    you_may_like: "You may also like",
    related: "Related Products",
  },
  academy: {
    eyebrow: "Fayriza Academy",
    hero_title: "Learn from India's Best Stylists",
    hero_sub: "Professional beauty & grooming courses taught by certified experts. Learn at your own pace, earn certificates, and launch your career.",
    search_placeholder: "Search courses or instructors…",
    stats_courses: "Expert Courses",
    stats_students: "Students Enrolled",
    stats_rating: "Average Rating",
    stats_certificate: "Certificate Included",
    all: "All Courses",
    makeup: "Makeup",
    hair: "Hair",
    skin: "Skin",
    nails: "Nails",
    grooming: "Grooming",
    courses: "Courses",
    course: "Course",
    enroll: "Enroll Now",
    enrolled: "Enrolled",
    modules: "Modules",
    instructor: "Instructor",
    duration: "Duration",
    level: "Level",
    level_beginner: "Beginner",
    level_intermediate: "Intermediate",
    level_advanced: "Advanced",
    certificate: "Certificate",
    no_courses: "No courses match your filters",
    my_enrollments: "My Courses",
    continue_learning: "Continue Learning",
    completed: "Completed",
  },
  notifications: {
    title: "Notifications",
    empty: "You're all caught up",
    empty_sub: "No new notifications right now",
    mark_all_read: "Mark all as read",
    just_now: "Just now",
    minutes_ago: "{{n}}m ago",
    hours_ago: "{{n}}h ago",
    days_ago: "{{n}}d ago",
  },
  ai: {
    title: "Fayriza AI Advisor",
    subtitle: "Personalised beauty recommendations, powered by AI.",
    placeholder: "Ask anything about skin, hair, makeup…",
    send: "Send",
    examples_title: "Try asking",
    ex_1: "Best haircut for my face shape?",
    ex_2: "Skincare routine for oily skin",
    ex_3: "Bridal makeup trends 2026",
    thinking: "Thinking…",
    disclaimer: "Suggestions are informational. For medical concerns, consult a professional.",
  },
  marketing: {
    about: {
      eyebrow: "Our Story",
      title: "Beauty, reimagined",
      sub: "Fayriza was born from a simple idea — India deserves a salon booking experience as refined as its craft.",
      mission_title: "Our Mission",
      mission_body: "To connect millions of beauty enthusiasts with India's finest salons through a seamless, trusted, and luxurious platform.",
      vision_title: "Our Vision",
      vision_body: "A world where everyone has access to quality beauty and wellness services at their fingertips.",
      values_title: "Our Values",
      value_1_title: "Quality First",
      value_1_body: "Every partner salon is verified and held to our premium standards.",
      value_2_title: "Customer Obsessed",
      value_2_body: "Your experience is our north star — from booking to aftercare.",
      value_3_title: "Empowering Partners",
      value_3_body: "We grow when our salons and stylists grow.",
      cta_title: "Be part of the story",
      cta_sub: "Join the Fayriza community today.",
    },
    how_it_works: {
      eyebrow: "How It Works",
      title: "Book in three steps",
      sub: "Premium beauty, without the guesswork.",
      step_1_title: "Discover",
      step_1_body: "Browse verified salons, services, and stylists near you.",
      step_2_title: "Book",
      step_2_body: "Pick a time that works — confirmed instantly.",
      step_3_title: "Enjoy",
      step_3_body: "Get pampered. Rate your visit. Earn rewards.",
      faq_title: "Quick Questions",
    },
    partners: {
      eyebrow: "For Salon Owners",
      title: "Grow with Fayriza",
      sub: "Reach new clients, fill empty chairs, and run a modern salon.",
      benefit_1_title: "More Customers",
      benefit_1_body: "Access India's largest premium beauty audience.",
      benefit_2_title: "Smart Booking",
      benefit_2_body: "Manage schedules, staff, and services from one dashboard.",
      benefit_3_title: "Instant Payments",
      benefit_3_body: "Secure, fast payouts — no manual chasing.",
      cta: "Become a Partner",
    },
    stylists: {
      eyebrow: "For Stylists",
      title: "Build your clientele",
      sub: "Showcase your work, get discovered, and grow your career.",
      cta: "Apply as a Stylist",
    },
    careers: {
      eyebrow: "Careers",
      title: "Shape the future of beauty",
      sub: "We're a small team building something big. Want in?",
      openings_title: "Open Roles",
      no_openings: "No openings right now. Drop us a note at careers@fayriza.com.",
    },
    contact: {
      eyebrow: "Get in Touch",
      title: "We'd love to hear from you",
      sub: "Questions, feedback, or partnership ideas — we're all ears.",
      name: "Your Name",
      email: "Your Email",
      message: "Message",
      send: "Send Message",
      sent: "Thanks — we'll get back within 24 hours.",
      support_email: "Support",
      partners_email: "Partners",
      media_email: "Media",
    },
    faq: {
      eyebrow: "Help",
      title: "Frequently Asked Questions",
      sub: "Quick answers to common questions.",
    },
    legal: {
      privacy_title: "Privacy Policy",
      terms_title: "Terms of Service",
      refund_title: "Refund Policy",
      last_updated: "Last updated {{date}}",
    },
  },
  errors: {
    network: "Network error — check your connection",
    unauthorised: "Please sign in to continue",
    forbidden: "You don't have access to this",
    not_found: "We couldn't find what you're looking for",
    server: "Server error — please try again later",
    validation: "Please check the highlighted fields",
    generic: "Something went wrong",
    page_not_found_title: "Page not found",
    page_not_found_sub: "The page you're looking for has moved or no longer exists.",
    go_home: "Go to Home",
  },
};

export default en;
